module.exports = __webpack_public_path__ + "img/logo.e37eec7b.svg";